<template>
    <AppHeaderDropdown right no-caret show>
        <template slot="header">
            <b-nav-item class="d-md-down-none">
                <i class="icon-grid" style="color: #fff;"></i>
            </b-nav-item>
        </template>
        <template slot="dropdown">
            <b-dropdown-item   disabled  v-if="!isReport"><i class="fa fa-briefcase" /> Auftragswesen</b-dropdown-item>
            <b-dropdown-item   disabled v-if="isReport"><i class="fa fa-bar-chart" /> Auswertungen</b-dropdown-item>
          <b-dropdown-item   v-on:click="triggerAuftragsbuch"  v-if="isReport"><i class="fa fa-briefcase" style="color: black"/> Auftragswesen</b-dropdown-item>
          <b-dropdown-item   v-on:click="triggerAuswertung" v-if="hasModule(33) && !isReport"><i class="fa fa-bar-chart" style="color: black"/> Auswertungen</b-dropdown-item>
          <b-dropdown-item   v-on:click="triggerPersonalwesen" v-if="hasModule(13)"><i class="fa fa-calendar" style="color: black"/> Personalwesen</b-dropdown-item>
          <b-dropdown-item   v-on:click="triggerPersonalwesen" v-if="hasModule(14) && !hasModule(13)"><i class="fa fa-calendar" style="color: black"/> Rufbereitschaft</b-dropdown-item>
          <b-dropdown-item   v-on:click="triggerMobileSettings" v-if="hasModule(12)"><i class="fa fa-mobile-phone" style="color: black"/>Einstellungen Mobile Geräte</b-dropdown-item>
            <b-dropdown-item v-on:click="triggerBaumkontrolle" v-if="hasModule(5)"><i class="fa fa-tree" style="color: black"/>Baumkontrolle</b-dropdown-item>
            <b-dropdown-item v-on:click="triggerNutzerverwaltung" v-if="hasModule(6)"><i class="fa fa-users" style="color: black"/>Nutzerverwaltung</b-dropdown-item>
            <b-dropdown-item v-on:click="triggerFuhrpark" v-if="hasModule(26)"><i class="fa fa-car" style="color: black"/>Fuhrparkverwaltung</b-dropdown-item>
            <b-dropdown-item  v-if="isDemo"><i class="fa fa-child" style="color: black"/>Spielplatzkontrolle</b-dropdown-item>
            <b-dropdown-item  v-if="isDemo"><i class="fa fa-road" style="color: black"/>Straßenkontrolle</b-dropdown-item>
            <b-dropdown-item  v-if="isDemo"><i class="fa fa-map" style="color: black"/>GPS-Nachweis</b-dropdown-item>
            <b-dropdown-item v-on:click="triggerAdmin" v-if="isAdmin && false"><i class="fa fa-wrench" style="color: black"/>Administration</b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
    import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
    import {test} from "@/shared/utils";
    export default {
        name: 'ChangeModuleDropdown',
        components: {
            AppHeaderDropdown
        },
        props:{
            isAdmin: {
                type: Boolean,
                default: () => false
            },
            modules: {
                type: Array,
                default: () => []
            },
            isReport: {
                type: Boolean,
                default: () => false
            }

        },
      created: function () {
        this.isDemo = test;
        if (this.$cookies.get("ps_customer_number") === "7678986") {
          this.isDemo = true;
        }
      },
      computed: {
      },
      data() {
        return {
          isDemo: false,
          hasReporting: false,
        }
        },
        methods: {
            hasModule(module) {
                for (let i = 0; i < this.modules.length; i++) {
                    if (this.modules[i] === module) {
                        return true;
                    }
                }
                return false
            },
          triggerAuftragsbuch() {
            window.location = 'https://auftragsbuch.bisoffice.app/';
          },
            triggerAdmin() {
                this.$emit('admin');
            },
            triggerBaumkontrolle() {
                this.$emit('baumkontrolle');
            },
            triggerNutzerverwaltung() {
                this.$emit('nutzerverwaltung');
            },
            triggerMobileSettings() {
                this.$emit('mobileSettings');
            },
          triggerPersonalwesen() {
            this.$emit('zk');
          },
          triggerFuhrpark() {
            this.$emit('fp');
          },
          triggerAuswertung() {
            window.location = 'https://auftragsbuch.bisoffice.app/#/reporting/reports/PSA';
          },
        }
    }
</script>
